export default __webpack_public_path__ + "static/media/taxefy_logo.977890d4.png";